import { styled } from '@mui/material/styles';

import { Theme } from '../../theme';

export const StyledGroupedUnorderedList = styled('ul')`
    ${({ theme }: { theme: Theme }) => `
        padding: ${theme.tggSpacing(0, 0)};
        margin: ${theme.tggSpacing(0, 0)};
        list-style: none;
	`}
`;
